export default __webpack_public_path__ + "static/media/huma-eva-00.a24f8662.jpg";